if (!customElements.get('hoculus-atc')) {
    class HoculusAtc extends HTMLElement {
        constructor() {
            super();
            this.variantId = this.dataset.variantId;
            this.button = this.querySelector('button.hoculus-atc-button');
            this.errorEl = document.querySelector(this.dataset.errorSelector);
        }

        connectedCallback() {
            this.addEventListener('click', this.addToCart.bind(this));
        }

        addToCart() {
            let formData = {
                'items': [{
                    'id': Number(this.variantId),
                    'quantity': 1
                }]
            };

            this.button.classList.add("btn--loading");
            this.button.disabled = true;

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(response => {
                    return response.json();
                })
                .then(res => {
                    
                    if (res.status) {
                        this.errorEl.textContent = res.message;
                        this.errorEl.classList.remove("hoculus-hidden");
                        setTimeout(() => {
                            this.errorEl.classList.add("hoculus-hidden");
                        }, 6000);
                    } else {
                        this.button.disabled = false;
                        this.classList.add("success");
                        setTimeout(() => {
                            this.classList.remove("success");
                        }, 1500);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                })
                .finally(()=> {
                    this.button.classList.remove("btn--loading");
                    // document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
                    document.dispatchEvent(new CustomEvent("cart:build"));
                });
                
        }
    }
    customElements.define("hoculus-atc", HoculusAtc);
}